import { roundNumber } from '../../util/number';

const toMoneyNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Recalcula totais derivados de um item mensal a partir dos campos de entrada.
 * Replica as fórmulas atuais da tela (sem ajuda de custo).
 */
export const calculateMonthlyItemTotals = (item) => {
  const producao = toMoneyNumber(item?.producao);
  const variavel = toMoneyNumber(item?.variavel);
  const reembolso = toMoneyNumber(item?.reembolso);
  const descontosDiversos = toMoneyNumber(item?.descontosDiversos);
  const adiantamento = toMoneyNumber(item?.adiantamento);

  const totalRendimentos = roundNumber(producao + variavel + reembolso, 2);
  const totalDebitos = roundNumber(descontosDiversos + adiantamento, 2);
  const liquido = roundNumber(totalRendimentos - totalDebitos, 2);

  return { totalRendimentos, totalDebitos, liquido };
};

/**
 * Mescla um patch no item e consolida campo + totais derivados na mesma operação.
 */
export const mergeMonthlyItemValues = (item, patch = {}) => {
  const merged = { ...item, ...patch };
  return {
    ...merged,
    ...calculateMonthlyItemTotals(merged),
  };
};

/**
 * Atualiza um item da folha preservando a identidade dos demais itens.
 */
export const updatePayrollItemValues = (payroll, itemId, patch) => {
  if (!payroll?.items) {
    return payroll;
  }

  let didChange = false;
  const items = payroll.items.map((item) => {
    if (item.id !== itemId) {
      return item;
    }
    didChange = true;
    return mergeMonthlyItemValues(item, patch);
  });

  if (!didChange) {
    return payroll;
  }

  return {
    ...payroll,
    items,
  };
};
